import Message from 'shared_components/message';
import { API_POST_METHOD } from 'global_config/constant-global';
import { axiosLabAPI } from '../axios';

const createPatientInfo = async (personalInfo) => {
	let createdPatient;
	const {address, addressCode, city, contactNumber, dateOfBirth, emailAdd, givenName, lastName, middleName, nameSuffix, provinces, sex, town, userID} = personalInfo;
	console.log('personalInfo =>', personalInfo);
	try{
		const content = {
			method: API_POST_METHOD,
			url: 'patient/info',
			data:{
				p_userid: userID,
				// p_patient_demographics_id: null,
				p_last_name: lastName,
				p_given_name: givenName,
				p_middle_name: middleName,
				p_suffix: nameSuffix,
				p_date_of_birth: dateOfBirth,
				p_sex: sex,
				p_address_name: address,
				p_address_code: addressCode,
				p_contact_number: contactNumber,
				p_email_address: emailAdd,
			} 
		}

		const response = await axiosLabAPI(content);
		const { data } = await response;

		createdPatient = data.RECORDS.at(0);
	}
	catch(error) {
		if(error && error.response && error.response.data) {
			const { errors } = error.response.data;
			Object.keys(errors).forEach(key => { Message.error(errors[key]); });
		}

		createdPatient = null;
	}

	return createdPatient;
}

export default createPatientInfo;